module.exports = __webpack_public_path__ + "static/media/galerija_2013 (22).08dec489.jpg";